<template>
<div class="page">
    <!-- Header -->
    <div class="header-view-bg">
    <b-container>
        <div class="header-view">
            <div @click="navTo('home')">
                <img class="logo-img header-logo-img" :src="require('@/assets/img/pageicon/header-logo.png')" />
            </div>
            <div class="header-btn active" @click="navTo('performances')" >
                <div class="mes-exp">{{ $t('header.myExploits') }}</div>
                <b-icon icon="plus-circle"></b-icon>
            </div>
            <!-- <div class="header-btn" @click="navTo('replay')" >
                <div class="mes-exp">{{ $t('header.replayHeader') }}</div>
            </div> -->
            <i18n-dropdown />
            <!-- <notoficatio /> -->
            <!-- User profile dropdown -->
            <b-nav-item-dropdown class="align-selfdrop-down" >
                <template #button-content>
                    <slot name="title">
                        <div class="avtar-icon">
                            <img class="avtar-icon-img" :src="profilePicture" />
                        </div>
                    </slot>
                </template>
                <b-dropdown-item class="cust-list-item" @click="navTo('profile')" >{{ $t('header.profile') }}</b-dropdown-item>
                <b-dropdown-item class="cust-list-item" @click="logout">{{ $t('header.logout') }}</b-dropdown-item>
            </b-nav-item-dropdown>
        </div>
    </b-container>
    </div>
    <!-- Content -->
    <div class="page-block" >
        <b-container class="page-block-bg">
            <b-row class="text-center">
                <b-col cols="12" md="12">
                    <breadcrumb v-if="this.$route.meta.breadcrumb" :route="this.$route" />
                </b-col>
            </b-row>
            <router-view />
        </b-container>
    </div>
    <!-- Footer -->
    <div class="footer-block">
        <div class="container">
            <div class="text-center row">
                <div class="col-md-3 sm-text-bottom">
                    <div class="footer-left-align">
                        <img class="logo-img" :src="require('@/assets/img/pageicon/footer-logo.png')" />
                    </div>
                    <div class="footer-left-align pd-25">
                        <span class="copy">&copy;</span> 2021 Spomo
                    </div>
                    <div class="footer-left-align pd-25">
                        <img class="ft-img" :src="require('@/assets/img/pageicon/version-logo.png')" />
                        Version alpha test
                    </div>
                </div>
                <div class="col-md-3 sm-text">
                    <div class="footer-left-align bold-text">{{ $t('footer.aPropos') }}</div>
                    <div class="footer-left-align"><a href="http://www.spomo.io" target="_blank">{{ $t('footer.aPropos') }}</a></div>
                    <!-- <div class="footer-left-align">{{ $t('footer.confidentialityPolicy') }}</div> -->
                    <div class="footer-left-align"><b-link href="#" @click="navTo('cgu')">{{ $t('footer.cg') }}</b-link></div>
                    <!-- <div class="footer-left-align">À propos de nos cartes</div> -->
                </div>
                <div class="col-md-3 ls-sm-text">
                    <div class="footer-left-align bold-text">{{ $t('footer.register') }}</div>
                    <div class="footer-left-align">
                        <a href="https://www.instagram.com/spomofr/" target="_blank"><v-icon class="shre-logo-img" name="brands/instagram" scale="2"></v-icon></a>
                        <a href="https://twitter.com/SpomoFr" target="_blank"><v-icon class="shre-logo-img" name="brands/twitter" scale="2"></v-icon></a>
                        <a href="https://www.linkedin.com/company/spomofr" target="_blank"><v-icon class="shre-logo-img" name="brands/linkedin" scale="2" ></v-icon></a>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="footer-left-align bold-text">{{ $t('footer.help') }}</div>
                    <div class="footer-left-align">
                        <!-- <img class="shre-logo-img-mail" :src="require('@/assets/img/pageicon/send-email.png')" /> -->
                        <div class="footer-left-align">
                          <b-link href="#" @click="navTo('helpImport')" style="display: block">{{ $t('footer.helpImport') }}</b-link>
                          <a href="mailto:hello@spomo.io"><v-icon class="shre-logo-img" name="envelope" scale="2" style="display: block"></v-icon></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import i18nDropdown from "@/components/Ui/i18nDropdown";
import notoficatio from "@/components/Ui/notoficatio";
import Breadcrumb from "@/components/Ui/Breadcrumb";
export default {
    components: {
        i18nDropdown,
        notoficatio,
        Breadcrumb
    },
    methods: {
        navTo(routeName) {
            this.$router.push({
                name: routeName,
            });
        },
        logout() {
            this.$store.dispatch('Auth/logout')
                .then(() => {
                    this.$store.dispatch('success', 'Logout Success')
                    this.navTo('login');
                });
        },
    },
    computed:{
        profilePicture(){
            const storeUser = this.$store.getters['Auth/user'];
            if(storeUser != null && storeUser.photo != null){
                return storeUser.photo;
            }else{
                return 'https://www.gravatar.com/avatar/default?s=200&r=pg&d=mm';
            }
        }
    },
    created() {
        /*
        this.$store.dispatch('Auth/getUser')
            .then((data) => {
            })
            .catch((error) => {
                this.$store.dispatch('errors', {
                    error: error
                })
            });
        */
    }
};
</script>

<style scoped>
.dropdown .dropdown-toggle {
    cursor: pointer;
}

a {
    color:grey;
}
</style>
